import { emptyObj } from 'util/objects'
import { emptyArray } from 'util/arrays'
import { createSelector } from 'reselect'
import { selectIsUnread as selectIsUnreadFromSearches } from 'ducks/searches/selectors'
import { selectIsInChat } from 'selectors/location'

export function selectBase(state) {
  return state.realtime || emptyObj
}

export const selectUnreadRoomIds = createSelector(
  selectBase,
  realtime => realtime.unreadRoomIds || emptyArray
)

export const selectIsUnread = createSelector(
  selectBase,
  selectIsInChat,
  selectIsUnreadFromSearches,
  (realtime, isInChat, isUnreadFromSearches) =>
    isInChat ? isUnreadFromSearches : realtime.unread || false
)
